import { formatInTimeZone } from "date-fns-tz";

export const AEST = "Australia/Melbourne";

export const fmtClock = (d) => formatInTimeZone(d, AEST, "HH:mm:ss");
export const fmtDate = (d) => formatInTimeZone(d, AEST, "EEEE, dd-MM-yyyy");
export const fmtDateTime = (iso) =>
  iso ? formatInTimeZone(new Date(iso), AEST, "dd-MM-yyyy HH:mm") : "—";
export const fmtTime = (iso) =>
  iso ? formatInTimeZone(new Date(iso), AEST, "HH:mm") : "—";

// Format a plain 'yyyy-MM-dd' string as 'dd-MM-yyyy'
export const fmtISODate = (s) => {
  if (!s) return "—";
  const [y, m, d] = s.split("-");
  return `${d}-${m}-${y}`;
};

// value for <input type="datetime-local"> in AEST from an ISO string
export const toLocalInput = (iso) =>
  iso ? formatInTimeZone(new Date(iso), AEST, "yyyy-MM-dd'T'HH:mm") : "";
